<template>
  <div class="setHome">
    <div class="header">
      <div class="back" @click="back" v-if="$route.name != 'DeviceSet'">
        <div class="back-arr">
          <div class="back-arr-top"></div>
          <div class="back-arr-bottom"></div>
        </div>
        <div class="back-txt">返回</div>
      </div>
      <div class="title">{{ $route.matched[2].meta.showTxt }}</div>
    </div>
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Page",
  components: {},
  computed: {
    ...mapState(["xiaoDuStatus", "allData"]),
  },
  methods: {
    back() {
      this.$router.back();
    },
  },
  mounted() {
    console.log(this.$route.matched, "this.$route.matched");
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
